var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDildoIconColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-1e31ddbc-9fcd-4a58-b2d4-cdc92031c095",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 555.94 934.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-20f98f03-cb59-4e3a-9991-cf927af15ada {\n        fill: url(#uuid-f39923fb-6e87-4455-b198-d1dacfc72969);\n        opacity: .98;\n        stroke-width: 0px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "uuid-f39923fb-6e87-4455-b198-d1dacfc72969",
    x1: 277.97,
    y1: 831.65,
    x2: 277.97,
    y2: 135.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#2e8f68"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#61e0ad"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-20f98f03-cb59-4e3a-9991-cf927af15ada",
    d: "M.28,934.33h555.66s0-24.48-.84-63.51c-.6-28.03-2.26-64.85-59.21-99.63-33.33-20.35-36.53-30.42-37.93-47.92-.17-2.17,2.74-34.53-3.61-39.54-5.89-4.65-20.34-3.32-27.5-6.47-18.36-8.08,33.55-60.81,33-117.36-.89-91.42-64.1-84.6-66.64-155.19-2.36-65.56,27.64-76.16,26.37-131.8-1.65-72.49-41.98-92.8-13.75-118.39,5.64-5.11,9.02-6.82,12.23-12.2,16.68-27.95-80.92-27.55-117.22-117.56-4.17-10.33-24.98-28.56-41.8-24.07-13.86,3.7-27.72,17-13.75,35.46,1.01,1.34-7.82,19.58-10.19,22.78-22.1,29.85-63.22,103.76-60.15,200.05,2.43,76.38,22.45,67.96,24.98,159.95,1.39,50.56-33.14,68.35-32.63,137.1.54,72.65,68.04,102.54,47.72,119.8-4.87,4.14-17.07,3.53-24.65,8.53-17.48,11.55-9.42,43.69-11.98,46.37-43.54,45.6,19.83,28.89-84.22,51.47S.28,934.33.28,934.33Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDildoIconColor);
export default __webpack_public_path__ + "static/media/DildoIcon(Color).0a18fa013079651dab429a29e4de1410.svg";
export { ForwardRef as ReactComponent };